import MemberStatistic from "./MemberStats";
import Layout from "../../components/layouts";
import DeathStatistic from "./DeathStats";
import LoginStatistic from "./LoginStats";
import WebSiteStatistic from "./WebsiteStats";

const Statistic = () => {

    return (
        <Layout className='d-flex flex-column'>
            <MemberStatistic />
            <DeathStatistic />
            <LoginStatistic />
            <WebSiteStatistic />
        </Layout>
    );
};

export default Statistic;
